/*  MUI  */
import { Avatar } from '@mui/material';

/*  Shared  */
import { DarkTooltip } from 'application/Shared/Components/Tooltips';

/*  Utils  */
import { Env } from 'application/Shared/Utils';

/*  React  */
import React, { CSSProperties } from 'react';

const IMAGE_HOST = Env.get('REACT_APP_IMAGE_HOST', { required: true });

interface ImageProps {
    /** The ID of the image to display */
    imageId: string;

    /** The alternative text for the image */
    alt?: string;
    /** Whether the image is an avatar */
    avatar?: boolean;
    /** The class name for the image */
    className?: string;
    /** The size of the image */
    size?: string;
    /** The style for the image */
    style?: CSSProperties;
    /** The text for the image */
    text?: string;
    /** The tooltip text for the image */
    tooltipText?: string;
    /** The placement of the tooltip */
    tooltipPlacement?:
        | 'top'
        | 'bottom'
        | 'left'
        | 'right'
        | 'top-start'
        | 'top-end'
        | 'bottom-start'
        | 'bottom-end'
        | 'left-start'
        | 'left-end'
        | 'right-start'
        | 'right-end';
    'aria-label'?: string;
}

export const Image = ({
    imageId,
    avatar,
    text,
    style,
    className,
    alt,
    tooltipText,
    tooltipPlacement = 'bottom',
    size = '16',
    'aria-label': ariaLabel = 'image'
}: ImageProps) => {
    const src = `${IMAGE_HOST}/applications/${imageId}-${size}.webp`;
    let ImageComponent: React.ReactNode = null;

    // Set the style from size if it is provided
    const sx = {
        ...style,
        ...(size && { height: `${size}px`, width: `${size}px` })
    };

    if (avatar) {
        if (text) {
            ImageComponent = (
                <Avatar style={sx} className={className} src={src}>
                    {text}
                </Avatar>
            );
        } else {
            ImageComponent = (
                <Avatar style={sx} className={className} src={src} />
            );
        }
    } else {
        ImageComponent = (
            <img
                alt={alt}
                aria-label={ariaLabel}
                className={className}
                src={src}
                style={sx}
            />
        );
    }

    return tooltipText ? (
        <DarkTooltip arrow title={tooltipText} placement={tooltipPlacement}>
            {ImageComponent}
        </DarkTooltip>
    ) : (
        ImageComponent
    );
};
